import React, { useState, useCallback } from 'react';
import { Card } from '@material-ui/core';
import { observer } from 'mobx-react';
import { useHistory } from 'react-router-dom';

import { useStore } from 'core/store';
import useSession from 'core/hooks/use-session';
import { Label } from 'core/components/label';
import { Button } from 'core/components/button';
import { track } from 'core/helpers/analytics';
import OfferConfigurationModal from 'offer/components/settings/offer-configuration-modal';
import undoIcon from 'customer/assets/undo.svg';
import icHistory from 'core/assets/svg/icHistory.svg';
import icSettings from 'core/assets/svg/icSettings.svg';

import useStyles from './offer-tools.styles';

const OfferTools = observer(() => {
  const classes = useStyles();
  const history = useHistory();
  const {
    offer: offerStore,
    quote: { setPrefillData }
  } = useStore();
  const { offer } = offerStore;
  const { user } = useSession();
  const [showOfferConfigModal, setShowOfferConfigModal] = useState(false);

  const toggleOfferConfigModal = useCallback(() => setShowOfferConfigModal((prev) => !prev), []);

  const onRegenerateClick = useCallback(() => {
    track('Staff Requote - staff user', {
      message: 'Manual regenerate from offer tools',
      offerId: offer.id,
      staffUsername: user.username,
      webUserId: offer.webUserId,
      offerType: offer.quote.selectedOption
    });
    setPrefillData(offer);
    history.push('/quote');
  }, [offer, user, setPrefillData, history]);

  // Offers without a parent go straight to the arbitrary-compare page.
  const onCompareClick = useCallback(() => {
    const comparePath = offer?.parentId ? 'compare' : 'compare-arbitrary-offers';
    window.open(`/offer/${offer.id}/${comparePath}`, '_blank');
  }, [offer]);

  return (
    <>
      <Label variant="body3" className={classes.header}>
        Offer tools
      </Label>
      <Card id="offer_tools" className={classes.container}>
        <Button color="secondary" variant="text" className={classes.textButton} onClick={toggleOfferConfigModal}>
          <img src={icSettings} alt="settings" className={classes.actionButtonIcon} />
          Advanced configuration
        </Button>
        <Button color="secondary" variant="text" className={classes.textButton} onClick={onCompareClick}>
          <img src={icHistory} alt="compare" className={classes.actionButtonIcon} />
          Compare to parent offer
        </Button>
        <Button color="secondary" variant="text" className={classes.textButton} onClick={onRegenerateClick}>
          <img src={undoIcon} alt="regenerate" className={classes.actionButtonIcon} />
          Regenerate from scratch
        </Button>
      </Card>
      {showOfferConfigModal && <OfferConfigurationModal open={showOfferConfigModal} onClose={toggleOfferConfigModal} />}
    </>
  );
});

export default OfferTools;
